import PaintBrush from './PaintBrush';

export default PaintBrush;
